/* eslint-disable*/
/* @todo: eslint fix and proper documentation */
'use strict';

// base include
var base = require('deborla/storeLocator/storeLocator');

// Variables
var map;
var allStoresName = $('.store-name');
/* globals google */

/**
 * Uses google maps api to render a map
 */
function maps() {
    var infowindow = new google.maps.InfoWindow();

    var grayStyles = [
        {
            elementType: 'geometry',
            stylers: [
                {
                    color: '#f5f5f5'
                }
            ]
        },
        {
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#616161'
                }
            ]
        },
        {
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    color: '#f5f5f5'
                }
            ]
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#bdbdbd'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#eeeeee'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#757575'
                }
            ]
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#e5e5e5'
                }
            ]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#757575'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#dadada'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#616161'
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#e5e5e5'
                }
            ]
        },
        {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#eeeeee'
                }
            ]
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#c9c9c9'
                }
            ]
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#9e9e9e'
                }
            ]
        }
    ];

    // Init Portugal Map in the center of the viewport
    var latlng = new google.maps.LatLng(39.399872, -8.224454);
    var mapOptions = {
        scrollwheel: false,
        zoom: 5,
        center: latlng,
        styles: grayStyles,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
        },
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        gestureHandling: 'greedy'
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        url: window.ImageResource,
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        scaledSize: new google.maps.Size(40, 40)
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            targetZoom: 22,
            icon: markerImg,
            anchor: new google.maps.Point(40, 40)
        });

        /**
         * Animate map zoom
         * @param {Object} targetZoom - Target zoom level
         * @param {Object} commandedZoom - Current zoom level
         */
        function animateMapZoomTo(targetZoom, commandedZoom) {
            var currentZoom = commandedZoom || map.getZoom();
            if (currentZoom !== targetZoom) {
                google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
                    animateMapZoomTo(map, targetZoom, currentZoom + (targetZoom > currentZoom ? 1 : -1));
                });
                setTimeout(function () {
                    map.setZoom(currentZoom + (targetZoom > currentZoom ? 1 : -1));
                }, 500);
            }
        }

        // Open marker informations
        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
            map.panTo(this.getPosition());
            var newZoom = map.getZoom() + 2;
            if (map.getZoom() <= 5) {
                animateMapZoomTo(map, 10);
            } else {
                animateMapZoomTo(map, newZoom);
            }
        });

        // close marker informations
        map.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.close(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);

        allStoresName.each(function () {
            var storeId = '#' + $(this).attr('id');

            if (marker.title === this.textContent) {
                $('body').on('click', storeId, function () {
                    infowindow.setOptions({
                        content: item.infoWindowHtml
                    });
                    infowindow.open(map, marker);
                    map.panTo(marker.getPosition());
                    if (map.getZoom() <= 5) {
                        animateMapZoomTo(map, 10);
                    }
                });
            }
        });
    });

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length > 0) {
        map.fitBounds(bounds);
    }

    var listener = google.maps.event.addListener(map, 'idle', function () {
        if (map.getZoom() > 16) {
            map.setZoom(15);
        }
        google.maps.event.removeListener(listener);
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();

        // checkout pickup-in-store
        $('.select-store').attr('disabled', true);
        $('.pickup-in-store .store-locator-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').hide();
        $('#availability-state-container .store-locator-no-results').show();
    } else if (data.radius === 10000) {
        $('.store-locator-no-results').show();

        // checkout pickup-in-store
        $('.select-store').attr('disabled', true);
        $('.pickup-in-store .store-locator-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').show();
        $('#availability-state-container .store-locator-no-results').hide();
    } else {
        $('.store-locator-no-results').hide();

        // PDP - availability in store
        $('.store-locator-avaiable-stores').show();
        $('#availability-state-container .store-locator-no-results').hide();
    }

    $resultsDiv.empty().data('has-results', hasResults).data('radius', data.radius).data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 *
 * @param {*} radius
 */
function updateRadius(radius) {
    radius = 10000;

    var url = $('.store-locator-container .district-select').data('action-url');
    var urlParams = {};

    urlParams = {
        radius: radius
    };

    url = appendToUrl(url, urlParams);
    var dialog = $(this).closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            $('.select-store').prop('disabled', true);
            updateStoresResults(data);
        }
    });
}

/**
 * Availability state
 */
function availabilityState() {
    require('improove/util/states').add('availability', $('.state-container--availability'), $('.availability-state-trigger'), {});
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @param {number} radius
 * @returns {boolean} false to prevent default event
 */
function search(element, radius = 100) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    var storeLocatorPostalCode = $('#store-postal-code').val();

    if (!storeLocatorPostalCode) {
        radius = 10000;
    }

    var url = $form.attr('action');
    var urlParams = { radius: radius };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();

            var storeResults = $('#store-locator-results .card-body');
            var isCheckout = $('.checkout-pickup-instore');

            // quick fix to prevent storelocator code running inside checkout
            if (isCheckout.length == 0) {
                updateStoresResults(data, element);
                if (storeResults.length > 0 && storeResults.length < 2) {
                    radius += 25;
                    search(element, radius);
                } else if (storeResults.length == 0) {
                    updateRadius(radius);
                }
            }
        }
    });
    return false;
}

// we removed this function as it was repeting the same event and action than changeDistrictPDP which serves both store page and check store in PDP
base.changeDistrict = function () {
};

base.search = function (forceSearch) {
    $('.store-locator-wrapper .store-locator-container form.store-locator').submit(function (e) {
        e.preventDefault();
        search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
        e.preventDefault();
        search($(this));
    });
    if (forceSearch) {
        search($('.store-locator'));
    }
};

base.updateSelectStoreButton = function () {
    $('body').on('change', '.select-store-input', function () {
        $('.select-store').prop('disabled', false);
        $('.select-store').click();
    });
};

base.openAvailabilityState = function () {
    $('.availability-state-trigger').on('click', function () {
        var noSelection = '1';
        var url = $(this).data('action-url');
        var productID = document.querySelector('[class="product-id"]');
        if (productID) {
            document.cookie = 'pidPdp=' + productID.innerText + ';path=/';
        }
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.select-store').prop('disabled', true);
                updateStoresResults(data);
            }
        });
        availabilityState();
        $('#district').val(noSelection);
        $('.background_black_overlay-pdp').removeClass('d-none');
        $('.state-container--availability').removeClass('d-none');
        $('body').addClass('state-container--availability-fixer');
    });
};

module.exports = base;
